import { DashboardPageFormField } from '@shigo-ui/dashboard-ui';
import { Input, Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@shigo-ui/ui';
import { Controller, useFormContext } from 'react-hook-form';

import { ShigoPermission } from '../../../../auth/permissions';
import { useShigoPermissions } from '../../../../auth/useShigoPermissions';
import { dashboardT } from '../../../../../lib/messages';
import { TargetingStatus, type TargetingBuilderFormValue } from '../../model';

export function TargetingBuilderIdentityFields() {
  'use no memo';

  const { can } = useShigoPermissions();
  const canArchive = can(ShigoPermission.TargetingArchive);
  const {
    control,
    formState: { errors },
    register,
  } = useFormContext<TargetingBuilderFormValue>();
  const nameId = 'targeting-builder-name';
  const statusId = 'targeting-builder-status';
  return (
    <div className="grid gap-5">
      <DashboardPageFormField
        label={dashboardT('targetingBuilder.name')}
        htmlFor={nameId}
        required
        error={errors.name?.message}
      >
        <Input
          id={nameId}
          required
          aria-invalid={Boolean(errors.name)}
          placeholder={dashboardT('targetingBuilder.namePlaceholder')}
          {...register('name')}
        />
      </DashboardPageFormField>
      <DashboardPageFormField
        label={dashboardT('targetingBuilder.activity')}
        htmlFor={statusId}
        required
      >
        <Controller
          control={control}
          name="status"
          render={({ field }) => (
            <Select value={field.value} onValueChange={field.onChange}>
              <SelectTrigger id={statusId} aria-label={dashboardT('targetingBuilder.activity')}>
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                {Object.values(TargetingStatus).map((status) => (
                  <SelectItem
                    key={status}
                    value={status}
                    disabled={status === TargetingStatus.Archived && !canArchive}
                  >
                    {dashboardT(`targetingBuilder.statuses.${status}`)}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          )}
        />
      </DashboardPageFormField>
    </div>
  );
}
